if (!customElements.get('neji-slider')) {
  customElements.define('neji-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.nf-slide-track');
      const slides = Array.from(track.children);
      const buttons = Array.from(this.querySelectorAll('[data-slide]'));
      const go = (index) => {
        const bounded = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: slides[bounded].offsetLeft - slides[0].offsetLeft,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      this.goTo = go;
      buttons.forEach(button => button.addEventListener('click', () => go(Number(button.dataset.slide))));
      track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        go(Math.round(track.scrollLeft / track.clientWidth) + (event.key === 'ArrowRight' ? 1 : -1));
      });
      track.addEventListener('scroll', () => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        buttons.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.slide) === index)));
      }, { passive: true });
    }
  });
}


function setupNejiCardColors(root = document) {
 root.querySelectorAll('[data-neji-card]').forEach(card => {
  if(card.dataset.colorsReady) return;
  card.dataset.colorsReady = 'true';
  card.querySelectorAll('[data-card-swatch]').forEach(button => button.addEventListener('click', () => {
   const image = card.querySelector('.nf-card-photo img');
   if(image && button.dataset.image) { image.removeAttribute('srcset'); image.src = button.dataset.image; image.alt = button.dataset.alt; }
   card.querySelectorAll('[data-card-link]').forEach(link => link.href = button.dataset.url);
   card.querySelectorAll('[data-card-swatch]').forEach(swatch => swatch.setAttribute('aria-pressed', String(swatch === button)));
   card.querySelector('[data-card-color]').textContent = button.dataset.color;
   card.querySelector('[data-card-status]').textContent = button.dataset.status;
   const price = card.querySelector('[data-card-price]');
   const tax = price.querySelector('small');
   price.replaceChildren(document.createTextNode(button.dataset.price + ' '));
   if(tax) price.append(tax);
  }));
 });
}
setupNejiCardColors();
document.addEventListener('shopify:section:load', event => setupNejiCardColors(event.target));
if(!customElements.get('neji-product')) customElements.define('neji-product', class extends HTMLElement {
 connectedCallback() {
  if(this.ready) return;
  this.ready = true;
  const variants = JSON.parse(this.querySelector('[data-product-variants]').textContent);
  let selected = variants.find(variant => String(variant.id) === this.dataset.variant) || variants[0];
  const options = [...this.querySelectorAll('[data-product-option]')];
  const update = variant => {
   selected = variant;
   options.forEach(option => {
    const active = variant.options[Number(option.dataset.optionIndex)] === option.dataset.optionValue;
    if(active) option.setAttribute('aria-current', 'true'); else option.removeAttribute('aria-current');
   });
   this.querySelectorAll('[data-option-group]').forEach(group => group.querySelector('[data-option-name]').textContent = variant.options[Number(group.dataset.optionGroup)]);
   this.querySelector('[data-product-price]').textContent = variant.price;
   this.querySelector('[data-product-status]').textContent = variant.available ? this.dataset.ready : this.dataset.soldout;
   const input = this.querySelector('input[name="id"]'); if(input) input.value = variant.id;
   const add = this.querySelector('[data-product-add]'); if(add) { add.disabled = !variant.available; add.textContent = variant.available ? this.dataset.add : this.dataset.soldout; }
   this.querySelector('[data-product-notice]').hidden = variant.available;
   const gallery = this.querySelector('neji-slider');
   const index = [...gallery.querySelectorAll('[data-image-id]')].findIndex(slide => slide.dataset.imageId === variant.image);
   if(index >= 0 && gallery.goTo) gallery.goTo(index);
   const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
  };
  options.forEach(option => option.addEventListener('click', event => {
   if(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
   const index = Number(option.dataset.optionIndex), value = option.dataset.optionValue;
   const nextOptions = [...selected.options]; nextOptions[index] = value;
   const variant = variants.find(candidate => candidate.options.every((v, i) => v === nextOptions[i])) || variants.find(candidate => candidate.options[index] === value && candidate.available) || variants.find(candidate => candidate.options[index] === value);
   if(!variant) return;
   event.preventDefault(); update(variant);
  }));
 }
});
